import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fedex': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M586 284.5L639.3 224.6H576.9L555.2 249.4 532.7 224.6H414V208.6H470.1V160.5H318.9V236H318.4C308.8 225 296.9 221.2 283 221.2 254.6 221.2 233.2 240.6 225.7 266.1 207.7 206.7 128.3 208.5 103.8 252.1V227.9H49V201.7H109V160.6H0V345H49V267.5H97.9C96.4 273.2 95.6 279.3 95.6 285.7 95.6 358.8 198.2 377.1 225.8 309.4H183.8C169.1 330.3 138 318.3 138 294.8H223.5C227.2 325.3 250.9 351.7 283.6 351.7 297.7 351.7 310.6 344.8 318.5 333.1H319V345H531.2L553.3 320 575.6 345H640L586 284.5zM139.3 267.9C145.4 241.6 181 242.3 185.8 267.9H139.3zM292.7 316.8C258.1 316.8 258.7 254 292.7 254 325.3 254 327.2 316.8 292.7 316.8zM460.5 335.9H366.1V169.4H461.1V199.6H405V233.5H460.5V261.6H404.4V306.3H460.5V335.9zM414.6 296.1V271.7H470.7V227.7L521.4 284.7 470.7 341.7V296.1H414.6zM553.2 306.4L527.1 335.9H489L534.6 284.7 489 233.5H528.7L555.3 262.8 580.9 233.5H619.4L574 284.5 620 335.9H579.5L553.2 306.4z'
      }
    ]
  }
})
